import {UtmDataType} from 'store/types';

/**
 * Removes any trailing decimal digits from a numeric value and returns the result as a string.
 * If the input value is not provided or falsy, an empty string is returned.
 *
 * @param value - The numeric value to remove trailing decimals from.
 * @returns A string representation of the input value with trailing decimal digits removed.
 */
export const removeDecimals = (value?: number): string => {
  if (!value) return '';
  return value?.toFixed(2).replace('.00', '');
};

export function parseUTM(url: string): UtmDataType | undefined {
  const urlParams = new URLSearchParams(new URL(`https://straus.md/${url}`).search);
  if (!urlParams.get('utm_source')) return;
  const utmParams: UtmDataType = {
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || '',
    utm_id: urlParams.get('utm_id') || '',
  };
  return utmParams;
}

/**
 * Convert meters to km
 * @param meters  1000
 * @returns    1
 */
export const convertMetersToKm = (meters: number) => {
  if (meters < 0) return 0;
  return `${(meters / 1000).toFixed(1)} km`;
};
